import React,{useEffect} from "react";
import Fade from '@material-ui/core/Fade';

const TeamContent = ({style}) => {

    useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

    return (
        <div style={style}>
            {/* section five */}
            <section className="message about-section">
                <div className="anchor" id="about"></div>
                <div className="container-main">
                    <div className="description">
                        <h3>За нас</h3>
                        <p>Ние вярваме, че имаш правото да се застраховаш с лекота. Затова създадохме Nu INS - приложението, което прави застраховането лесно, достъпно и прозрачно за теб. В стремеж към коренна промяна, въз основа на опита в застраховането, комбиниран
                            с опита в развитието на иновативни технологични продукти, направихме процеса на сключване на застраховка максимално кратък за теб.</p>
                    </div>
                    <div className="list">
                        <div className="item left">
                            <div className="image">
                        
                                    <img src="/img/team/nikoleta-aleksieva.png" alt="Николета Алексиева" />
                        
                            </div>
                            <div className="content">
                                <figure>
                                    <img src="/img/logo-dark.png" alt="Nu INS logo" />
                                </figure>
                                <h2>Николета Алексиева</h2>
                                <h3>Изпълнителен Директор</h3>
                                <p>От идеята, носеща разрешение на конкретен проблем на пазара, през оперативните процеси, поставени в законодателната рамка за извършване на дейността, привличането на таланти в организацията и мотивацията им за постигане на корпоративните цели чрез осъществяването на личните им кариерни планове, до заслужено доверие от страна на клиентите. 
                                    Това е двигателя към успеха за развитието на едно софтуерно решение в бизнес, генериращ стойност за потребителите, създателите и общността.</p>
                            </div>
                        </div>
                        {/*
                        <div className="item right">
                            <div className="image">
                    
                                    <img src="/img/team/pavel-panayotov.png" alt="Павел Панайотов" />
                        
                            </div>
                            <div className="content">
                                <figure>
                                    <img src="/img/logo-dark.png" alt="Nu INS logo" />
                                </figure>
                                <h2>Павел Панайотов</h2>
                                <h3>Директор Бизнес Развитие</h3>
                                <p>Професионалист с четвърт век опит в бизнес развитието и управлението на продажби, извървял пътя от стартиращ предприемач, през ръководител на стратегически телекомуникационни проекти до директор на няколко застрахователни и пенсионно-осигурителни дружества. За него, Nu INS е поглед в бъдещето и неизбежна крачка от еволюцията на застрахователния бизнес!</p>
                            </div>
                        </div>
    */}
                        <div className="item right">
                            <div className="image">
                    
                                    <img src="/img/team/desislava-lazarova.jpg" alt="Десислава Лазарова" />
                    
                            </div>
                            <div className="content">
                                <figure>
                                    <img src="/img/logo-dark.png" alt="Nu INS logo" />
                                </figure>
                                <h2>Десислава Лазарова</h2>
                                <h3>Директор Операции</h3>
                                <p>Експерт с богат и разнообразен опит в застраховането и човек с изключителен поглед върху детайла, умеещ да подреди еквилибриума от застрахователни рискове и най-подходящи за клиента покрития, превеждайки му с лекота застрахователната материя на на човешки език. 
                                    Убедено вярва, че Nu INS e крачка към свободата, клиентът да избира кога, къде и какво да застрахова!</p>
                            </div>
                        </div>
                        <div className="item left">
                            <div className="image">
                                <figure>
                                    <img src="/img/team/svetoslav-moldovanski.jpg" alt="Светослав Молдовански" />
                                </figure>
                            </div>
                            <div className="content">
                                <figure>
                                    <img src="/img/logo-dark.png" alt="Nu INS logo" />
                                </figure>
                                <h2>Светослав Молдовански</h2>
                                <h3>Основател, IT Manager</h3>
                                <p>Светослав е двигател на техническия екип, пренася своя дългогодишен опит в дигиталната трансформация на банкови услуги в застрахователната индустрия, за да превърне Nu INS в иновативно решение, което дава сигурност, свобода и индивидуално
                                    изживяване на клиента.</p>
                            </div>
                        </div>
                        <div className="item right">
                            <div className="image">
                                <figure>
                                    <img src="/img/team/peter-aleksiev.jpg" alt="Петър Алексиев" />
                                </figure>
                            </div>
                            <div className="content">
                                <figure>
                                    <img src="/img/logo-dark.png" alt="Nu INS logo" />
                                </figure>
                                <h2>Петър Алексиев</h2>
                                <h3>Финансов Мениджър</h3>
                                <p>Петър внася в Nu INS своя ентусиазъм за бъдещето на мобилните технологии във всички сфери на бизнеса. Той има богат и разнообразен опит в областта на финансите, натрупан в седем страни на три континента.</p>
                            </div>
                        </div>
                    
                        <div className="item left">
                            <div className="image">
                                <figure>
                                    <img src="/img/team/mariana-ivanova.jpg" alt="Мариана Иванова" />
                                </figure>
                            </div>
                            <div className="content">
                                <figure>
                                    <img src="/img/logo-dark.png" alt="Nu INS logo" />
                                </figure>
                                <h2>Мариана Иванова</h2>
                                <h3>UX Дизайнер</h3>
                                <p>След 8 години опит в създаването на корпоративни приложения, страстта на Мариана, продължава да бъде процесът на разбиране и учене, тъй като вярва, че във всяко взаимодействие между клиента и продукта съществува път на обучение. Затова
                                    нейната цел е да елиминира объркването на потребителя и да създаде пълноценно и приятно изживяване за клиентите на Nu INS.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

const Team = () => {
    return (
        <div style={{position: 'realtive', paddingTop: '40px'}}>
            <Fade in={true} timeout={{enter: 600, exit: 0}} disableStrictModeCompat={true}>
              <TeamContent />
            </Fade>
        </div>
    )
}

export default Team;

